module.exports = __webpack_public_path__ + "img/[再见].37c47134.svg";